import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-messaging',
    templateUrl: './messaging.component.html',
    styleUrls: ['./messaging.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagingComponent { }
